import React from 'react';
import {
  BackToTopButton,
  ButtonLink,
  Container,
  Header1,
  Header3,
  Paragraph,
  VerticalSpacing,
} from '@we-agile-you/react-base';
import { Navigation } from '../../organisms/Navigation/Navigation';

const STEPS = [
  {
    title: 'Step 1: Understanding Your Cards',
    content: (
      <>
        <Paragraph>[0; 1; 2; 3; 5; 8; 13; 21; 34; 55; 89; 100]</Paragraph>
        <VerticalSpacing spacing="spacing-m" />
        <Paragraph>
          Each player is given the same number of cards with the same values.
          The objective is to vote for how much effort a particular project
          development task will require.
        </Paragraph>
      </>
    ),
  },
  {
    title: 'Step 2: Story Reading',
    content: (
      <>
        <Paragraph>
          The Scrum Master (Project Manager) will present a story to the group.
        </Paragraph>
      </>
    ),
  },
  {
    title: 'Step 3: Development Discussion',
    content: (
      <>
        <Paragraph>
          This is where each team member will give more details on the important
          aspects about the task.
        </Paragraph>
      </>
    ),
  },
  {
    title: 'Step 4: Estimate and Share',
    content: (
      <>
        <Paragraph>
          All agile development team members will then choose a card from their
          deck to represent their estimate of story points. Once everyone has
          made their decision, all cards will be revealed. The higher the count,
          the more complex the particular project aspect will be.
        </Paragraph>
      </>
    ),
  },
  {
    title: 'Step 5: Come to a Consensus',
    content: (
      <>
        <Paragraph>
          If all members reveal the same card, that number becomes the consensus
          – and the team can move on to the next story. If card values differ,
          further discussion with persuasive reasoning will be needed to
          determine why individual values were chosen. This process is repeated
          until a consensus is reached.
        </Paragraph>
      </>
    ),
  },
];

export const WhatsPlanningPokerTemplate = () => {
  return (
    <>
      <Navigation isShowShadowOnScrolled />

      <VerticalSpacing spacing="spacing-xxl-4" />
      <VerticalSpacing spacing="spacing-xxl-4" />

      <Container size="medium">
        <Header1>What is Planning Poker?</Header1>
        <VerticalSpacing spacing="spacing-xxl-4" />

        <Paragraph>
          Planning poker, also called Scrum poker, is a gamified technique for
          estimating tasks mostly used by Agile development teams.
        </Paragraph>
        <VerticalSpacing spacing="spacing-m" />

        <Paragraph>
          The game consists in looping through these steps for each task that
          the team wants to estimate:
        </Paragraph>

        {STEPS.map((step) => (
          <>
            <VerticalSpacing spacing="spacing-xl" />
            <Header3>{step.title}</Header3>
            <VerticalSpacing spacing="spacing-m" />
            <>{step.content}</>
          </>
        ))}

        <VerticalSpacing spacing="spacing-xxl-4" />

        <Header3>
          Would you like to try our planning poker online tool for free?
        </Header3>
        <VerticalSpacing spacing="spacing-m" />
        <Paragraph>
          <ButtonLink>
            Start a free planning poker online game for free
          </ButtonLink>
        </Paragraph>

        <VerticalSpacing spacing="spacing-xxl-4" />
        <VerticalSpacing spacing="spacing-xxl-4" />
      </Container>
      <BackToTopButton />
    </>
  );
};
